<template>
    <VuePerfectScrollbar ref="scrollbar">
        <slot />
    </VuePerfectScrollbar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar/index.vue'
    import { mapGetters } from 'vuex'

    export default {
        name: 'totem-scrollbar',
        components: {
            VuePerfectScrollbar
        },
        props: {
            shouldScrollOnInit: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                collectionPreviewScrollTop: 'CoursesCollections/getCollectionPreviewScrollTop'
            })
        },
        watch: {
            collectionPreviewScrollTop: {
                handler () {
                    if (this.shouldScrollOnInit && this.$refs.scrollbar !== undefined) {
                        this.$nextTick(() => {
                            this.$refs.scrollbar.$el.scrollTop = this.collectionPreviewScrollTop
                        })
                    }
                },
                immediate: true
            }
        }
    }
</script>
